import { render, staticRenderFns } from "./visit-confirm-distribution.vue?vue&type=template&id=c6518806&scoped=true"
import script from "./visit-confirm-distribution.vue?vue&type=script&lang=ts"
export * from "./visit-confirm-distribution.vue?vue&type=script&lang=ts"
import style0 from "./visit-confirm-distribution.vue?vue&type=style&index=0&id=c6518806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6518806",
  null
  
)

export default component.exports